// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-control {
  padding: 0 5px 5px;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  min-height: 40px;
  z-index: 0;
  overflow: auto;
}
.chartkit-control_line-breaks_wrap {
  white-space: normal;
}
.chartkit-control_line-breaks_nowrap:not(.chartkit-control_standalone) {
  white-space: nowrap;
}
.chartkit-control__controls_hidden {
  visibility: hidden;
}
.chartkit-control__controls_hidden .textinput__clear {
  display: none;
}
.chartkit-control:not(.chartkit-control_standalone) {
  background-color: var(--ck-controls-backgound);
  max-height: 50%;
  flex: none;
}
.chartkit-control__loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.chartkit-control__item {
  margin-top: 5px;
  max-width: 100%;
  width: var(--control-custom-width, "auto");
}
.chartkit-control__item_button {
  padding: 2px 0;
}
.chartkit-control__item_checkbox {
  padding: 6.5px 0;
}
.chartkit-control__item:not(:last-child) {
  margin-right: 10px;
}
.chartkit-control__error {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 16px 6px;
}
.chartkit-control__error-icon {
  color: var(--g-color-text-danger);
  flex: 0 0 auto;
}
.chartkit-control_mobile {
  min-height: 64px;
}
.chartkit-control_mobile .chartkit-control__controls {
  display: flex;
  flex-direction: column;
  padding-bottom: 6px;
}
.chartkit-control_mobile .chartkit-control__item {
  margin-right: 0;
  margin-top: 10px;
}
.chartkit-control_mobile .chartkit-control__error {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/Control/Control.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAQI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AARJ;AAUI;EACI,mBAAA;AARR;AAWI;EACI,mBAAA;AATR;AAaQ;EACI,kBAAA;AAXZ;AAcY;EACI,aAAA;AAZhB;AAiBI;EAEI,8CAAA;EACA,eAAA;EACA,UAAA;AAhBR;AAmBI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAjBR;AAoBI;EACI,eAAA;EACA,eAAA;EACA,0CAAA;AAlBR;AAqBQ;EACI,cAAA;AAnBZ;AAsBQ;EACI,gBAAA;AApBZ;AAuBQ;EACI,kBAAA;AArBZ;AAyBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;AAvBR;AA0BI;EACI,iCAAA;EACA,cAAA;AAxBR;AA2BI;EACI,gBAAA;AAzBR;AA2BQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAzBZ;AA4BQ;EACI,eAAA;EACA,gBAAA;AA1BZ;AA6BQ;EC8EJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADxGJ","sourcesContent":[".chartkit-control {\n  padding: 0 5px 5px;\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  min-height: 40px;\n  z-index: 0;\n  overflow: auto;\n}\n.chartkit-control_line-breaks_wrap {\n  white-space: normal;\n}\n.chartkit-control_line-breaks_nowrap:not(.chartkit-control_standalone) {\n  white-space: nowrap;\n}\n.chartkit-control__controls_hidden {\n  visibility: hidden;\n}\n.chartkit-control__controls_hidden .textinput__clear {\n  display: none;\n}\n.chartkit-control:not(.chartkit-control_standalone) {\n  background-color: var(--ck-controls-backgound);\n  max-height: 50%;\n  flex: none;\n}\n.chartkit-control__loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.chartkit-control__item {\n  margin-top: 5px;\n  max-width: 100%;\n  width: var(--control-custom-width, \"auto\");\n}\n.chartkit-control__item_button {\n  padding: 2px 0;\n}\n.chartkit-control__item_checkbox {\n  padding: 6.5px 0;\n}\n.chartkit-control__item:not(:last-child) {\n  margin-right: 10px;\n}\n.chartkit-control__error {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 10px 16px 6px;\n}\n.chartkit-control__error-icon {\n  color: var(--g-color-text-danger);\n  flex: 0 0 auto;\n}\n.chartkit-control_mobile {\n  min-height: 64px;\n}\n.chartkit-control_mobile .chartkit-control__controls {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 6px;\n}\n.chartkit-control_mobile .chartkit-control__item {\n  margin-right: 0;\n  margin-top: 10px;\n}\n.chartkit-control_mobile .chartkit-control__error {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
